import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LANGUAGE_REMEMBER, LANGUAGE } from 'consts';
import { en, es } from '../assets/language';
import { nikoStrings } from 'features/niko/strings';
import moment from 'moment';
import 'moment/locale/es';


// Los textos de Niko se suman acá y no viven en el diccionario principal: la feature se
// licencia aparte y su imagen core se construye sin ella, textos incluidos. En esa build
// `strings.js` se reemplaza por su versión vacía y el diccionario queda exactamente como
// estaba antes de que Niko existiera.
//
// Se importa `features/niko/strings` y NO el barrel `features/niko` a propósito: el
// barrel arrastra la VISTA del chat, que a su vez importa sus hooks, que importan
// `utils` — y este archivo lo carga `utils/index.js`. Ese ciclo dejaba a `utils` a medio
// inicializar y la app entera reventaba en el navegador con "Cannot access
// 'serviceGetTemplates' before initialization". `strings.js` no importa nada, así que
// cortar acá deshace el ciclo.
const resources = {
	en: {
		translation: { ...en, ...nikoStrings.en },
	},
	es: {
		translation: { ...es, ...nikoStrings.es },
	}
};

const defaultLanguage = LANGUAGE;
moment.locale(localStorage.getItem(LANGUAGE_REMEMBER) || defaultLanguage || 'es');

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem(LANGUAGE_REMEMBER) || defaultLanguage || 'es',
  fallbackLng: {
		default: ['es']
	},
	interpolation: {
		escapeValue: false,
		format: (value, format, lng) => {
			if (format === 'currentDate') return
			moment(value).locale(lng).format('LL');
			return value;
		},
	},
  debug: false
});

// Force recompile 4
